import logo from "../assets/brand/buildbright-logo.svg";

export default function BrandLockup() {
  return (
    <img
      src={logo}
      alt="BuildBright"
      className="h-14 w-auto select-none"
      draggable="false"
    />
  );
}
